export enum NotificationModeDTO {
  NORMAL_MODE = 'NORMAL_MODE'
}
